import React, {Component} from 'react';

import { Theme } from '@mui/material/styles';

import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar'; 
//import Avatar from '@mui/material/Avatar';
import Toolbar from '@mui/material/Toolbar';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import {grey} from '@mui/material/colors';
import HelpIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
//import UserIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import ConfIcon from '@mui/icons-material/Settings';
//import StatIcon from '@mui/icons-material/PieChart';
import MasterGrid from '../../components/layout/DynamicGrid';
import {helppost,apidownload} from '../../ajax';
import { extendedstyles } from '../appstyles';
import Button from '@mui/material/Button';
import {CenterGrid} from '../../components/layout';
import { Box } from '@mui/material';


const s:any ={
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
    py: 4,
  },
  paper: {
    maxWidth: 700,
    width: '100%',
    mx: 'auto',
  },
  helpform: {
    p: 4,
    textAlign: 'center',
    width: '100%',
  },
  titlebar: {
    color: 'white',
    textAlign: 'center',
    flex: 1,
    fontWeight: 500,
  },
  versionBox: {
    mb: 3,
    mt: 2,
  },
  versionText: {
    fontSize: '1.75rem',
    fontWeight: 600,
    color: 'primary.main',
    mb: 1,
  },
  systemName: {
    fontSize: '1.25rem',
    fontWeight: 500,
    color: 'text.primary',
    mb: 2,
  },
  featuresBox: {
    mb: 3,
    mt: 2,
  },
  featuresText: {
    fontSize: '1rem',
    color: 'text.secondary',
    lineHeight: 1.8,
  },
  downloadBox: {
    mb: 3,
    mt: 3,
  },
  downloadLink: {
    display: 'inline-block',
    textDecoration: 'none',
    color: 'primary.main',
    fontSize: '1rem',
    fontWeight: 500,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  summarybar: {
    backgroundColor: grey['100'],
  },
  logo: (theme:Theme)=> ({
    cursor: 'pointer',
    fontSize: 22,
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightLight,
    backgroundImage: 'url(lib/img/logo.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: '0 50%',
    backgroundColor: 'transparent',
    paddingLeft: 5,
    paddingRight: 5,
    height: 20,
    width: 25,
    [theme.breakpoints.down('sm')]:{
      display:'none',
    },
  }),
  help:{
    margin: 20
  }
  
};

class Help extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);

    this.state = {
      loading: false,
      count: 0,
      open: false,
      sbopen: false,
      sbmesg: '',
      username: '',
      password:'',
      showPassword: false,
      context: props.context,
      serviceid: 1,
      remember: false
    };
  }

  componentDidMount(){
    //this.loadhelp('main')();
  }

  loadhelp = (name:any) => () => {

  }

  load = async() => {
    console.log('starting onSubmit... ');
    const {code,service,mode,sconfig,record,onResponse,ft,ms,mt} = this.props;
    const {url,endpoint} = sconfig || {};
    const {formData} = this.state;
    //console.log('onsubmit.formdata:',formData);
    try{
      let s = service;
      let a = mode;
      let recs = (mode==='delete')?{rid:+(record.rid),stp:record.stp}:record;
      let params = Object.assign(recs,formData,{s,a,ft,ms,mt});
      //console.log('service request ',params);
      this.startLoading();
      const response:any = await helppost(params);
      //console.log('service response ',response);

      if (response.success){
        this.props.showNotification(response.sm,'success',response.st)
        onResponse(true,response);
      }
      else if(response.failure){
        if (response.en===60){
        }
        else{
          this.props.showNotification(response.message,response.type||'error',response.title)
        }
      }      
    }
    catch(err){
      const error:any = err || {};
      console.log('submit.error:',JSON.stringify(error));
      this.props.showNotification(error.message||"request failed",error.type||'warn',error.title||'Update Error');
    }
    finally{
      this.stopLoading();
    }
  }

  startLoading = () => {
    this.setState({loading:true});
  }

  stopLoading = () => {
    this.setState({loading:false});
  }

  onChange = (panel:any) => (expanded:any) => {
    this.setState((prev:any) => ({expanded:expanded?panel:null}));
  }

  onDownload = () => {
    let url = '/api/download/';
    let doc = 'user_guide.pdf';
    // const response:any = await apidownload(doc,url,auth,);


  }

  render() {
    //const {service,code,showNotification,setPage,setHome,classes, theme} = this.props;
    const {userData,classes = {}, theme} = this.props;
    //const unm = (userData.bd||{}).unm;
    const {expanded}  = this.state;
    const logosrc = '/api/logo/icon.png';
    const docsrc = '/api/download/user_guide.pdf';

    return (
      <Box sx={{...s.container}}>
        <Paper elevation={3} square={false} sx={{...s.paper}}>
          <AppBar position="static" color="primary">
            <Toolbar>
              <Box sx={{...s.logo}} style={{backgroundImage: `url(${logosrc})`}}/>
              <Typography variant="h4" sx={{...s.titlebar}}>
                Help & Documentation
              </Typography>
            </Toolbar>
          </AppBar>
          <Box component='form' sx={{...s.helpform}}>
            <Box sx={{...s.versionBox}}>
              <Typography variant="h5" sx={{...s.versionText}}>
                NTRMS 1.0
              </Typography>
            </Box>
            <Box sx={{...s.versionBox}}>
              <Typography sx={{...s.systemName}}>
                NTR Monitoring System
              </Typography>  
            </Box>
            <Box sx={{...s.featuresBox}}>
              <Typography sx={{...s.featuresText}}>
                Regulatory, Audit, Analytics, Monitoring, Reporting, Integration
              </Typography> 
            </Box>
            <Box sx={{...s.downloadBox}}>
              <Typography>
                <Box 
                  component='a' 
                  href={docsrc} 
                  download="user_guide.pdf"
                  sx={{...s.downloadLink}}
                >
                  Download NTRMS User Guide
                </Box>
              </Typography> 
            </Box>
          </Box>
        </Paper>
      </Box>
    );

  }

  
}

export default Help;
